import type { ReactNode } from "react";

type Tone = "ok" | "warn" | "bad" | "muted";

const tones: Record<Tone, string> = {
  ok: "bg-emerald-500/15 text-emerald-300 ring-1 ring-emerald-500/30",
  warn: "bg-amber-500/15 text-amber-300 ring-1 ring-amber-500/30",
  bad: "bg-rose-500/15 text-rose-300 ring-1 ring-rose-500/30",
  muted: "bg-zinc-500/15 text-zinc-400 ring-1 ring-zinc-500/30",
};

const dots: Record<Tone, string> = {
  ok: "bg-emerald-400 animate-pulse-slow",
  warn: "bg-amber-400",
  bad: "bg-rose-400",
  muted: "bg-zinc-500",
};

export function StatusPill({
  tone = "muted",
  children,
}: {
  tone?: Tone;
  children: ReactNode;
}) {
  return (
    <span className={`pill ${tones[tone]}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${dots[tone]}`} />
      {children}
    </span>
  );
}
